import { Options as Component, Vue } from 'vue-class-component';
import {ClientAdapter} from '@/common/core/clientAdapter';
// @ts-ignore
import config from 'config';

@Component({})
export class VueEx extends Vue {

  public static memberId: string = '';
  public static userName: string = '';
  public static status: number = 0;
  public static email: string = '';
  public config?: any;

  public clientAdapter: ClientAdapter = new ClientAdapter();

  created() {
    this.config = config;
  }

}
